var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Twitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ea0029;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M715.56,488.47a5.83,5.83,0,0,1-1.67.47,3,3,0,0,0,1.28-1.62,5.83,5.83,0,0,1-1.86.71,2.92,2.92,0,0,0-5,2,2.84,2.84,0,0,0,.07.66,8.27,8.27,0,0,1-6-3.05,2.82,2.82,0,0,0-.4,1.47,2.93,2.93,0,0,0,1.3,2.43,2.9,2.9,0,0,1-1.32-.36v0a2.92,2.92,0,0,0,2.34,2.87,2.8,2.8,0,0,1-.77.1,2.5,2.5,0,0,1-.55-.05,2.92,2.92,0,0,0,2.73,2,5.82,5.82,0,0,1-3.63,1.25,5.37,5.37,0,0,1-.7,0,8.31,8.31,0,0,0,12.8-7c0-.13,0-.25,0-.38a5.71,5.71,0,0,0,1.46-1.52Z",
    transform: "translate(-696.94 -481.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Twitter);
export default __webpack_public_path__ + "static/media/01_Twitter.15f2b835d3b024ed606a8e08b338b883.svg";
export { ForwardRef as ReactComponent };